module.exports = __webpack_public_path__ + "img/placeholder-ff21.a91734c9.jpg";